"use strict";
/*
vim: fileformat=unix syntax=Node.js tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.walkSimpleFilter = exports.toComplexFilterJson = void 0;
/**
 * Simplified filter class for witchery, ported from java.
 *
 * Java simplified filter was modified to support AppTE
 * Because AppTE needs constant type, in case of constant, it should be 2 entries "data", "type"
 * For example ["baz", "=", "1", "long"] or ["baz", "between", "1", "long", "2", "long"]
 * If type is not string or not "long", "string", "date", "dateTime" - it is treated as next constant without type
 *
 * Main syntax stored internally:
 * <code>{"and": [["foo", "=", "a"], ["bar", "is null"], {"or": [["baz", "=", "1"], ["bazz", "<>", 2]]}]}</code>.
 * Also may parse alternative even more simplified syntax:
 * <code>["and", ["foo", "=", "a"], ["bar", "is null"], ["or", ["baz", "=", "1"], ["bazz", "<>", 2]]]</code>.
 * Group operator by default is "and" and may be skipped:
 * <code>[["foo", "=", "a"], ["bar", "is null"]]</code>.
 *
 * This class is able to convert simplified filter to complex one and vice versa.
 * Also this class removes unnecessary groups when building final filter.
 * <code>["and", ["or", ["and", ["baz", "=", "1"]]]]</code> will become <code>[["baz", "=", "1"]]</code>.
 *
 * Note about filter arrays. Because almost every time syntax is the same, by default array is: <code>["column", "op", "value"]</code>.
 * For rare other cases, if column is at second place, it should be array of single string: <code>["column", "op", ["column"]]</code>.
 * For future may be extended to: <code>["column", "between", "value1", "value2"]</code> or <code>["column", "in", "value1", "value2", "value3"]</code>.
 *
 * @author aousov
 *
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
const err_1 = require("../err");
class SimpleFilter {
    constructor(node) {
        this._filterObject = SimpleFilter._parseSimpleJsonFilter(node);
    }
    static _invalidFilterException(filter) {
        return new err_1.InternalError(err_1.ErrorCode.unexpected, `Invalid filter: "${JSON.stringify(filter)}"`);
    }
    static _validateOp(op) {
        if (!SimpleFilter._GROUPS[op])
            throw new err_1.InternalError(err_1.ErrorCode.unexpected, `Invalid filter group: "${op}"`);
        return op;
    }
    /**
     * Parses simple json.
     *
     * Parses both, alternative and main syntax. Alternative syntax will be converted to main.
     * See class description about syntax.
     * @param node
     * @return
     */
    static _parseSimpleJsonFilter(node) {
        const _filterArray = [];
        //default
        let group = 'and';
        const makeFilter = function () {
            return { [group]: _filterArray };
        };
        let iterateNext;
        if (Array.isArray(node)) {
            // empty filter
            if (!node.length)
                return makeFilter();
            const next = node[0];
            //may be either group, or filter + default group
            if (typeof next === 'string') {
                group = this._validateOp(next);
                iterateNext = node.slice(1);
            }
            else if (typeof next === 'object') {
                //array or object
                //isArray case: [["id", "=", 1]] or [["or", ["id", "=", 1]]]
                //isObject case: [{"or": [["id", "=", 1]]}, {"or": [["id", "=", 2]]}]
                iterateNext = node;
            }
            else {
                throw this._invalidFilterException(node);
            }
        }
        else if (typeof node === 'object') {
            const keys = Object.keys(node);
            //empty filter
            if (!keys.length)
                return makeFilter();
            //more than one group
            if (keys.length !== 1)
                throw this._invalidFilterException(node);
            group = this._validateOp(keys[0]);
            const next = node[group];
            if (!Array.isArray(next)) {
                //array or object
                throw this._invalidFilterException(node);
            }
            iterateNext = next;
        }
        else {
            throw this._invalidFilterException(node);
        }
        for (const next of iterateNext) {
            //now we either have filter, or group array or group object
            if (Array.isArray(next)) {
                //filter will have 2-* elements, and second element will be string ("=", "<>", "is null", etc..)
                //group will have 1-* elements, and second element will be array or object
                if (next.length >= 2 && typeof next[1] === 'string') {
                    //here we may optimize, by just inserting JSON to our tree, without conversion, just check for primitives
                    next.forEach((f, index) => {
                        if (index <= 1) {
                            //column name and filter operator must be string
                            if (typeof f !== 'string')
                                throw this._invalidFilterException(next);
                        }
                        else {
                            //must be primitive, or array of single string for column names
                            // eslint-disable-next-line no-lonely-if
                            if (this._PRIMITIVES[typeof f]) {
                                /* ok */
                            }
                            else if (Array.isArray(f)) {
                                if (f.length != 1 || typeof f[0] !== 'string')
                                    throw this._invalidFilterException(next);
                            }
                            else {
                                throw this._invalidFilterException(next);
                            }
                        }
                    });
                    _filterArray.push(next);
                }
                else {
                    _filterArray.push(this._parseSimpleJsonFilter(next));
                }
            }
            else if (typeof next === 'object') {
                _filterArray.push(this._parseSimpleJsonFilter(next));
            }
            else {
                throw this._invalidFilterException(next);
            }
        }
        return makeFilter();
    }
    //doesn't check errors. to use in toString method. creates copy, filterObject node is left as is.
    //assumes input already checked for errors
    static _normalize(filterObject) {
        const group = Object.keys(filterObject)[0];
        const filterArray = filterObject[group];
        //empty filter
        if (!filterArray.length)
            return null;
        const filterArrayNormalized = [];
        for (const next of filterArray) {
            if (Array.isArray(next)) {
                filterArrayNormalized.push(next);
            }
            else {
                //child group, may either return {"and": [[1], [2]]} or [[1]] or null
                const childGroup = this._normalize(next);
                if (childGroup === null) {
                    //remove
                }
                else if (Array.isArray(childGroup)) {
                    //only one element
                    filterArrayNormalized.push(childGroup[0]);
                }
                else {
                    //complex
                    filterArrayNormalized.push(childGroup);
                }
            }
        }
        if (!filterArrayNormalized.length)
            return null;
        if (filterArrayNormalized.length === 1)
            return filterArrayNormalized;
        return { [group]: filterArrayNormalized };
    }
    toString() {
        const normalized = SimpleFilter._normalize(this._filterObject);
        if (!normalized)
            return '';
        return JSON.stringify(normalized);
    }
    //it is internal - therefore valid and normalized, no need to check again
    //if used with walker - should be normalized before with above function, to remove empty groups
    static _buildComplexJsonObject(filterObject, walker) {
        const group = Object.keys(filterObject)[0];
        const filterArray = filterObject[group];
        //empty filter
        if (!filterArray.length)
            return null;
        walker?.({
            event: 'beginGroup',
            bool: group,
        });
        const complexArray = this._buildComplexJsonArray(filterArray, walker);
        walker?.({
            event: 'endGroup',
            bool: group,
        });
        //may be true for empty flattened objects ["and", ["or, ["and"]]]
        if (!complexArray.length)
            return null;
        if (complexArray.length == 1)
            return complexArray[0];
        const complexJson = {
            bool: group,
            filter: complexArray,
        };
        return complexJson;
    }
    static _buildComplexJsonArray(filterArray, walker) {
        const complexArray = [];
        for (const next of filterArray) {
            if (Array.isArray(next)) {
                //simple filter array, may be uninitialized
                if (next.length < 2)
                    throw this._invalidFilterException(next);
                const compareArray = [];
                let index = 0;
                while (index < next.length) {
                    const f = next[index++];
                    //index + 1
                    if (index == 2)
                        continue;
                    if (index == 1) {
                        compareArray.push({ column: f });
                    }
                    else if (Array.isArray(f)) {
                        if (f.length != 1)
                            throw this._invalidFilterException(next);
                        compareArray.push({ column: f[0] });
                    }
                    else {
                        const obj = { const: f };
                        if (index < next.length && this._TYPES[next[index]])
                            obj.type = next[index++];
                        compareArray.push(obj);
                    }
                }
                const compareObj = {
                    compare: next[1],
                    filter: compareArray,
                };
                complexArray.push(compareObj);
                walker?.({
                    event: 'filter',
                    ...compareObj,
                });
            }
            else {
                //child group
                const childGroup = this._buildComplexJsonObject(next);
                if (!childGroup)
                    continue;
                //will always be one object node (either group or single element)
                complexArray.push(childGroup);
            }
        }
        return complexArray;
    }
    buildComplexJson() {
        let filterNode = SimpleFilter._buildComplexJsonObject(this._filterObject);
        if (filterNode && !Array.isArray(filterNode)) {
            //wrap object into array, as does FE
            filterNode = [filterNode];
        }
        return filterNode;
    }
    walkQuery(walker) {
        const normalized = SimpleFilter._normalize(this._filterObject);
        if (!normalized)
            return;
        if (Array.isArray(normalized)) {
            SimpleFilter._buildComplexJsonArray(normalized, walker);
        }
        else {
            SimpleFilter._buildComplexJsonObject(normalized, walker);
        }
    }
}
SimpleFilter._GROUPS = {
    and: true,
    or: true,
    not: true,
};
SimpleFilter._PRIMITIVES = {
    boolean: true,
    number: true,
    bigint: true,
    string: true,
};
SimpleFilter._TYPES = {
    string: true,
    long: true,
    date: true,
    dateTime: true,
    blob: true,
    seqId: true,
    decimal: true,
};
function toComplexFilterJson(node, { forceEmpty } = {}) {
    const builder = new SimpleFilter(node);
    //console.log(filter.toString());
    const filter = builder.buildComplexJson();
    //prevent dummy errors, when no filter is build, and query will return whole table
    if (!filter && !forceEmpty)
        throw new err_1.InternalError(err_1.ErrorCode.unexpected, 'Filter is empty, use forceEmpty to override');
    return filter;
}
exports.toComplexFilterJson = toComplexFilterJson;
function walkSimpleFilter(node, walker) {
    const filter = new SimpleFilter(node);
    filter.walkQuery(walker);
}
exports.walkSimpleFilter = walkSimpleFilter;
//# sourceMappingURL=simpleFilter.js.map